import Helper from "../../Helper";
import { Permission } from "../../models/Permission";
import { plotFetch } from "../Helper/ApiRequest";

export function getPermissions(
    team_id: number | null,
    project_id: number | null,
    user_id: number | null,
    timezone: string
): Promise<Permission[]> {
    const url = new URL(`${Helper.baseUrlWithPort()}/permissions`);

    if (team_id) {
        url.searchParams.append("team_id", team_id.toString());
    }

    if (project_id) {
        url.searchParams.append("project_id", project_id.toString());
    }

    if (user_id) {
        url.searchParams.append("user_id", user_id.toString());
    }

    return plotFetch(url.toString(), { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((permission: any) => Permission.fromApiObject(permission, timezone));
        })
        .catch((error) => {
            return [];
        });
}
